<template>
  <div class="passcode-input">
    <label v-if="label">{{ label }}</label>
    <input type="password"
           v-model="passcodeSync"
           pattern="[0-9]*"
           inputmode="numeric"
           :autocomplete="autocomplete"
           class="hide-input"
           @keypress="onKeyPress($event)"
           @input="onInput($event)"
           @click="clearInput()" />
    <template  v-for="(number, index) in lengthLimitation">
      <span :class="{ filled: passcodeSync[index], clear: passcodeSync[index] && lengthLimitation === 6 }" :key="number">{{ passcodeSync | stripNumber(index) }}</span>
    </template>
  </div>
</template>

<script>
  export default {
    name: "PasscodeInput",

    data(){
      return {
        passcodeSync: ''
      }
    },

    props: {
      autocomplete: { type: String, default: "off" },
      autoFocus: { type: Boolean, default: true },
      lengthLimitation: { type: Number, default: 4 },
      label: { type: String, default: '' },
      passcode: {type: String, default: '' }
    },

    mounted() {
      if (this.autoFocus) {
        this.setFocus()
      }
    },

    methods: {
      clearInput(){
        this.$emit('update:passcode', '')
      },

      onInput(event){
        const value = event.target.value
        const length = this.lengthLimitation
        if(value.length >= length){
          const truncatedValue = value.substr(0, length)
          this.passcodeSync = truncatedValue
          this.$emit('update:passcode', truncatedValue)
        }
      },

      onKeyPress(event){
        if(event.charCode < 48 || event.charCode > 57){
          event.preventDefault()
        }
      },

      setFocus() {
        this.$el.getElementsByTagName('input')[0].focus()
      }
    },

    filters: {
      stripNumber: (value, position) => {
        if(!value) return ''
        return value.toString()[position]
      }
    },

    watch:{
      passcode(newValue){
        this.passcodeSync = newValue
      }
    }
  }
</script>
